/* --------------------------------------------------
Import modules
-------------------------------------------------- */

import Equalizer from '@meteora-digital/equalizer';

/* --------------------------------------------------
Document Setup
-------------------------------------------------- */

window.equalizers = {};
let index = 0;
function addEqualizer(settings, ID) {
  if (window.equalizers[ID]) ID = `${ID}-${index}`;
  window.equalizers[ID] = new Equalizer(settings);
  index += 1;
}
DomObserver.observe('[data-equalize]', containers => {
  containers.forEach(container => {
    const ID = container.getAttribute('data-equalize');
    addEqualizer({
      container,
      identifiers: ID,
      rows: true
    }, ID);
  });
});
DomObserver.observe('[data-match-height]', containers => {
  containers.forEach(container => {
    const ID = container.getAttribute('data-match-height');
    addEqualizer({
      container,
      identifiers: ID,
      rows: false
    }, ID);
  });
});